import React, { useContext } from "react";
import StarsIcon from "@mui/icons-material/Stars";
import { MyContext } from "../../../MyContextApi";
import Flow from "../../../images/flow.png";
import NavBar from "../../Admin/Dashboard/NavBar";
import ReactProSidebar from "../../Admin/Dashboard/ReactProSidebar";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { Description, Warning } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const styles = {
  container: {
    display: "flex",
    gap: "24px",
    padding: "24px",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(120deg, #f6f8fc 0%, #e9f0f7 100%)",
    borderRadius: "8px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },

  card: {
    width: "100%",
    cursor: "pointer",
    height: "80%",
    position: "relative",
    boxShadow:
      "5px 6px 20px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
    transition: "all 0.3s ease",
    background: "linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)",

    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: "8px",
      padding: "2px",
      background: "linear-gradient(60deg, #1976d2, #90caf9, #1976d2)",
      WebkitMask:
        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "xor",
      maskComposite: "exclude",
      opacity: 0,
      transition: "opacity 0.3s ease",
    },

    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)",

      "&::before": {
        opacity: 1,
      },

      // Ensure underline expands on hover
      "& .underline": {
        width: "96px",
        filter: "brightness(1.2)",
      },
    },
  },

  violationCard: {
    "&::before": {
      background: "linear-gradient(60deg, #d32f2f, #ff7676, #d32f2f)",
    },
  },

  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center", // Center vertically
    textAlign: "center",
    padding: "24px !important",
    position: "relative",
    zIndex: 1,
    background:
      "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
    height: "100%", // Ensure it takes the full height of the card
    width: "100%", // Ensure it takes the full width
  },

  iconWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    marginBottom: "16px",
    transition: "all 0.3s ease",
  },
  blueprintIcon: {
    backgroundColor: "#e3f2fd",
    "& svg": {
      color: "#1976d2",
      fontSize: "32px",
      transition: "transform 0.3s ease",
    },
    "&:hover svg": {
      transform: "scale(1.1)",
    },
  },
  violationIcon: {
    backgroundColor: "#ffebee",
    "& svg": {
      color: "#d32f2f",
      fontSize: "32px",
      transition: "transform 0.3s ease",
    },
    "&:hover svg": {
      transform: "scale(1.1)",
    },
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "600",
    color: "#1a2027",
    marginBottom: "8px",
    transition: "color 0.3s ease",
    "&:hover": {
      color: "#1976d2",
    },
  },
  violationTitle: {
    "&:hover": {
      color: "#d32f2f",
    },
  },
  description: {
    color: "#64748b",
    marginBottom: "16px",
  },
  underline: {
    width: "48px",
    height: "4px",
    borderRadius: "2px",
    transition: "all 0.3s ease",
  },
  blueprintUnderline: {
    backgroundColor: "#1976d2",
    boxShadow: "0 0 8px rgba(25, 118, 210, 0.3)",
  },
  violationUnderline: {
    backgroundColor: "#d32f2f",
    boxShadow: "0 0 8px rgba(211, 47, 47, 0.3)",
  },
  cardHover: {
    "&:hover $underline": {
      width: "96px",
      filter: "brightness(1.2)",
    },
  },
};

export default function CrawledInformation() {
  const { viewMode, setViewMode } = useContext(MyContext);

  const navigate = useNavigate();

  return (
    <>
      <div className="container">
        <NavBar />

        <main className="session-main">
          <Box sx={styles.container}>
            <Card sx={styles.card} onClick={() => navigate("/flowdiagram")}>
              <CardContent sx={styles.cardContent}>
                <Box sx={{ ...styles.iconWrapper, ...styles.blueprintIcon }}>
                  <Description />
                </Box>
                <Typography sx={styles.title}>Blueprint of Project</Typography>
                <Typography sx={styles.description}>
                  View and manage project workflow and architecture diagrams
                </Typography>
                <Box
                  sx={{ ...styles.underline, ...styles.blueprintUnderline }}
                />
              </CardContent>
            </Card>

            <Card sx={styles.card} onClick={() => navigate("/violationrules")}>
              <CardContent sx={styles.cardContent}>
                <Box sx={{ ...styles.iconWrapper, ...styles.violationIcon }}>
                  <Warning />
                </Box>
                <Typography sx={styles.title}>
                  Violation Rules & Regulations
                </Typography>
                <Typography sx={styles.description}>
                  Access and review compliance guidelines and violation reports
                </Typography>
                <Box
                  sx={{ ...styles.underline, ...styles.violationUnderline }}
                />
              </CardContent>
            </Card>
          </Box>
        </main>

        {/* <CrawledSidebar /> */}
        <ReactProSidebar />
      </div>
    </>
  );
}
